module.exports = _.map;